import TemplateTagVariableForm from './TemplateTagVariableForm';

export default TemplateTagVariableForm;
